// [BD FEAT] JS for the slider view for the mobile view
function initCollectionIconSliderById(sectionId) {
  const wrapper = document.querySelector(`#collection-icon-text-slider-${sectionId}`);
  if (!wrapper) return;

  const items = wrapper.querySelectorAll('.collection-icon-text-item') || [];
  if (items.length === 0) return;

  const isTabletOrMobile = window.innerWidth <= 768;

  // Destroy previous Flickity instance if exists
  const existingFlkty = Flickity.data(wrapper);
  if (existingFlkty) {
    existingFlkty.destroy();
  }

  // Remove previous mode classes
  wrapper.classList.remove(
    'collection-icon-text-wrapper--slider',
    'collection-icon-text-wrapper--tablet-2-cols'
  );

  // Initialize based on item count
  if (isTabletOrMobile) {
    if (items.length > 2) {
      wrapper.classList.add('collection-icon-text-wrapper--slider');
      new Flickity(wrapper, {
        cellAlign: 'center',
        contain: true,
        pageDots: true,
        prevNextButtons: false,
        wrapAround: true
      });
    } else {
      wrapper.classList.add('collection-icon-text-wrapper--tablet-2-cols');
    }
  }
}

// Initialize all on first load
function initAllCollectionIconSliders() {
  document.querySelectorAll('.collection-icon-text-section[data-section-id]').forEach((wrapper) => {
    const sectionId = wrapper.getAttribute('data-section-id');
    if (sectionId) initCollectionIconSliderById(sectionId);
  });
}

document.addEventListener('DOMContentLoaded', initAllCollectionIconSliders);

// Shopify editor events
['shopify:section:load', 'shopify:section:select', 'shopify:block:select', 'shopify:block:deselect'].forEach((eventName) => {
  document.addEventListener(eventName, function (event) {
    if (event.detail?.sectionId) {
      initCollectionIconSliderById(event.detail.sectionId);
    }
  });
});

// On window resize, re-init all sliders with debounce
let resizeTimer;
window.addEventListener('resize', function () {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(() => {
    initAllCollectionIconSliders();
  }, 250); // Debounced for performance
});